/* @flow */

// import buildURL from 'axios/lib/helpers/buildURL';
import Axios from 'axios';

export type RequestDataType = Object;
export type RequestParamsType = Object;

export type RequestType = {
    route: string,
    params: RequestParamsType,
    method: string,
    data?: RequestDataType | null,
    raw: boolean,
};

export default function RestRequest(
    defaultRoute: string = '',
    defaultParams: RequestParamsType = {}
) {
    const request: RequestType = {
        route: defaultRoute,
        params: defaultParams,
        method: 'get',
        data: null,
        raw: false,
    };

    return {
        getRoute(): string {
            return request.route;
        },

        getUrl(): string {
            // return decodeURI(buildURL(request.route, request.params));
            return Axios.getUri({ url: request.route, params: request.params });
        },

        setRaw(raw: boolean) {
            request.raw = raw;
            return this;
        },

        setPreventDuplicates(preventDuplicates: boolean) {
            if (preventDuplicates) {
                request.cancelToken = Axios.CancelToken.source();
            }
        },

        setData(data: RequestDataType) {
            request.data = data;
            return this;
        },

        setMethod(method: string) {
            request.method = method;
            return this;
        },

        setParams(params: RequestParamsType) {
            request.params = params;

            return this;
        },

        async execute(api: any) {
            const { cancelToken } = request;
            const config = {
                params: request.params,
            };

            if (cancelToken) {
                cancelToken.cancel();
                request.cancelToken = Axios.CancelToken.source();
                config.cancelToken = request.cancelToken.token;
            }

            const hasData =
                ['put', 'patch', 'post'].indexOf(request.method) > -1;
            const args = hasData
                ? [request.route, request.data, config]
                : [request.route, config];

            // $FlowFixMe
            const response = await api[request.method](...args);

            if (request.raw || request.method === 'head') {
                return response;
            }

            if (response.data && response.data.data) {
                return response.data.data;
            }

            if (response.data && !hasData) {
                return response.data;
            }

            if (hasData) {
                return response;
            }

            return null;
        },
    };
}
